
import { useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";

export function IntroSection() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Add JSON-LD structured data for SEO
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Hour Tracker",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "description": "Hour Tracker is time tracking software for any workflow - simple, accurate, and free time-tracking tool designed for freelancers, consultants, and small business owners."
    });
    
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className="py-10 md:py-16 bg-gradient-to-b from-background to-muted/20">
      <div className="container max-w-4xl mx-auto px-4">
        <h1 className={`${isMobile ? 'text-3xl' : 'text-4xl md:text-5xl'} font-bold text-center mb-5 colorful-header`}>
          Hour Tracker
        </h1>
        <p className="text-xl md:text-2xl text-center text-muted-foreground mb-5">
          <span className="text-primary font-semibold">Time Tracking Software for Any Workflow</span> - Track Your Time & <span className="text-primary font-semibold">Maximize Your Earnings</span>
        </p>
        
        <div className="flex justify-center mb-8">
          <div className="h-1 w-20 bg-gradient-primary rounded-full"></div>
        </div>
        
        <div className="glass-card p-6 md:p-8 rounded-xl mb-6 shadow-colorful">
          <p className="text-base md:text-lg mb-5">
            Hour Tracker is <span className="highlight-text">time tracking software for any workflow</span> - simple, accurate, and free. 
            Designed for freelancers, consultants, and small business owners, it adapts to your unique workflow. 
            With an intuitive interface and essential features, it helps users track their time, organize projects, manage billings, and export invoices with ease.
          </p>
          
          <div className="flex justify-center">
            <Button 
              onClick={() => navigate("/auth")} 
              size="lg"
              className="animated-gradient-button group"
            >
              Get Started Now
              <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
